// Cache local de l'overview (stale-while-revalidate) : affiché immédiatement, remplacé à l'arrivée des données fraîches
const PREFIX = 'overview/cache/'
const MAX_PERIODS = 4
const MAX_AGE = 7 * 24 * 3600 * 1000

function key(userId) {
  return `${PREFIX}${userId || 'anonymous'}`
}

export function readCache(userId) {
  try {
    const raw = localStorage.getItem(key(userId))
    return raw ? JSON.parse(raw) || {} : {}
  } catch (e) {
    return {}
  }
}

function writeCache(userId, cache) {
  try {
    localStorage.setItem(key(userId), JSON.stringify(cache))
  } catch (e) {
    // quota dépassé ou stockage indisponible : on repart d'un cache vide plutôt que de bloquer
    try { localStorage.removeItem(key(userId)) } catch (err) { /* indisponible */ }
  }
}

export const periodCacheKey = period => JSON.stringify(period || {})

export function readPeriod(userId, period) {
  const entry = (readCache(userId).periods || {})[periodCacheKey(period)]
  return entry && Date.now() - entry.at < MAX_AGE ? entry.data : null
}

// Garde les MAX_PERIODS périodes les plus récemment consultées
export function writePeriod(userId, period, data) {
  const cache = readCache(userId)
  const periods = { ...(cache.periods || {}), [periodCacheKey(period)]: { at: Date.now(), data } }
  const kept = Object.entries(periods).sort((a, b) => b[1].at - a[1].at).slice(0, MAX_PERIODS)
  writeCache(userId, { ...cache, periods: Object.fromEntries(kept) })
}

export function readSection(userId, name) {
  const entry = readCache(userId)[name]
  return entry && Date.now() - entry.at < MAX_AGE ? entry.data : null
}

export function writeSection(userId, name, data) {
  const cache = readCache(userId)
  writeCache(userId, { ...cache, [name]: { at: Date.now(), data } })
}
